import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit } from '@angular/core';

import { Title } from '@angular/platform-browser';
import { CustomBarChartComponent } from '../../shared/components/custom-bar-chart/custom-bar-chart.component';
import { PrintFilterDataComponent } from '../../shared/components/print-filter-data/print-filter-data.component';
import { ChartTypeColorsEnum } from '../../utils/enums/chart-colors.enum';
import { IReportFilter } from '../../utils/interfaces/report-filter';
import { IAnswerDetail } from '../../utils/interfaces/summary-report';
import { PrintDocument } from '../print-document';

@Component({
  selector: 'app-print-analytical',
  standalone: true,
  imports: [CommonModule, PrintFilterDataComponent, CustomBarChartComponent],
  templateUrl:
    '../../main/report/report-data/analytical/analytical.component.html',
  styleUrl:
    '../../main/report/report-data/analytical/analytical.component.scss',
})
export class PrintAnalyticalComponent
  extends PrintDocument
  implements OnInit, AfterViewInit
{
  private readonly titleService = inject(Title);
  print = true;
  chartColorsEnum = ChartTypeColorsEnum;

  filter: IReportFilter | null = null;

  data!: { average: number; total: number; analyticalData: IAnswerDetail[] };

  ngOnInit(): void {
    this.handleData();
  }

  ngAfterViewInit(): void {
    this.reportReadyData();
  }

  protected override handleData(): void {
    const { data, filter } = this.activatedRoute.snapshot.data['data'];

    this.data = data;
    this.filter = filter;

    this.titleService.setTitle(
      this.changeTitlePage(
        'Relatório analítico',
        this.filter!.startDate,
        this.filter!.finishDate
      )
    );
  }

  protected override reportReadyData(): void {
    setTimeout(() => {
      this.printDocumentService.onDataReady();
    }, 3000);
  }
}
